import { render } from "./ExampleTestModal.vue?vue&type=template&id=61ae32f8&scoped=true&ts=true"
import script from "./ExampleTestModal.vue?vue&type=script&lang=ts"
export * from "./ExampleTestModal.vue?vue&type=script&lang=ts"

import "./ExampleTestModal.vue?vue&type=style&index=0&id=61ae32f8&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ae32f8"]])

export default __exports__